var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FaPlusCircle as IconAdd } from 'react-icons/fa';
import * as SharedStyle from '../../shared-style';
import '../../styles/index.css';

var STYLE_TAG = {
  display: 'inline-block',
  background: '#337ab7',
  color: SharedStyle.COLORS.white,
  padding: '1px 4px',
  marginRight: '3px',
  borderRadius: '3px'
};

var CatalogItem = function (_Component) {
  _inherits(CatalogItem, _Component);

  function CatalogItem(props) {
    _classCallCheck(this, CatalogItem);

    var _this = _possibleConstructorReturn(this, (CatalogItem.__proto__ || Object.getPrototypeOf(CatalogItem)).call(this, props));

    _this.state = { hover: false };
    return _this;
  }

  _createClass(CatalogItem, [{
    key: 'select',
    value: function select() {
      var element = this.props.element;
      switch (element.prototype) {
        case 'lines':
          this.context.linesActions.selectToolDrawingLine(element.name);
          break;
        case 'items':
          this.context.itemsActions.selectToolDrawingItem(element.name);
          break;
        case 'holes':
          this.context.holesActions.selectToolDrawingHole(element.name);
          break;
        case 'areas':
          this.context.areaActions.selectToolDrawingArea(element.name);
          break;
        case 'pipes':
          this.context.pipesActions.selectToolDrawingPipe(element.name);
          break;
      }

      this.context.projectActions.pushLastSelectedCatalogElementToHistory(element);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var element = this.props.element;
      var hover = this.state.hover;

      return React.createElement(
        'div',
        {
          className: this.props.isSidebar ? "item-box-sidebar" : "item-box",
          onClick: function onClick(e) {
            return _this2.select();
          },
          onMouseEnter: function onMouseEnter(e) {
            return _this2.setState({ hover: true });
          },
          onMouseLeave: function onMouseLeave(e) {
            return _this2.setState({ hover: false });
          }
        },
        React.createElement(
          'b',
          { className: this.props.isSidebar ? "item-title-sidebar" : "item-title" },
          element.info.title
        ),
        React.createElement(
          'div',
          { className: this.props.isSidebar ? "item-image-container-sidebar" : "item-image-container" },
          React.createElement(
            'div',
            { className: this.props.isSidebar ? "item-image-sidebar" : "item-image", style: { backgroundImage: 'url(' + element.info.image + ')' } },
            hover ? React.createElement(IconAdd, { className: this.props.isSidebar ? "item-image-plus-sidebar" : "item-image-plus" }) : null
          )
        ),
        !this.props.isSidebar ? React.createElement(
          'ul',
          { className: 'item-tags' },
          element.info.tag.map(function (tag, index) {
            return React.createElement(
              'li',
              { className: _this2.props.isSidebar ? "item-tag-sidebar" : "item-tag", key: index },
              tag
            );
          })
        ) : null,
        React.createElement(
          'div',
          { className: this.props.isSidebar ? "item-description-sidebar" : "item-description" },
          element.info.description
        )
      );
    }
  }]);

  return CatalogItem;
}(Component);

export default CatalogItem;


CatalogItem.propTypes = {
  element: PropTypes.object.isRequired,
  isSidebar: PropTypes.bool
};

CatalogItem.contextTypes = {
  itemsActions: PropTypes.object.isRequired,
  linesActions: PropTypes.object.isRequired,
  holesActions: PropTypes.object.isRequired,
  projectActions: PropTypes.object.isRequired,
  areaActions: PropTypes.object.isRequired,
  pipesActions: PropTypes.object.isRequired
};